declare var krt: any;

type IdentifyEventParameter = {
  user_id: string;
  email: string;
};

type AttributeEventParameter = {
  organization_id: string;
  organization_name: string;
}

class User {
  userIdentifyEvent({ user_id, email }: IdentifyEventParameter) {
    if ('krt' in window) {
      krt('send', 'identify', {
        user_id: user_id,
        email: email,
        subscription: true // 原則としてメールは送信可能
      })
    } else {
      console.info(JSON.stringify({ user_id, email }, null, '\t'));
      console.info('karteタグが読み込まれていません。');
    }
  }

  userAttributeEvent({ organization_id, organization_name }: AttributeEventParameter) {
    if ('krt' in window) {
      krt('send', 'attribute', {
        "organization_id": organization_id,
        "organization_name": organization_name
      });
    } else {
      console.info(JSON.stringify({ organization_id, organization_name }, null, '\t'));
      console.info('karteタグが読み込まれていません。');
    }
  }

  userLoginEvent() {
    if ('krt' in window) {
      krt('send', 'login', { status: true });
    } else {
      console.info('karteタグが読み込まれていません。');
    }
  }

  userLogoutEvent() {
    if ('krt' in window) {
      krt('send', 'login', { status: false });
    } else {
      console.info('karteタグが読み込まれていません。');
    }
  }
}

export default new User();
